import { faDiagramProject } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { classNames } from '@framework/utils';
import type { PredictiveViewModelTag } from '@view-model/domain/view-model/ViewModelTagOperation';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

type ItemProps = {
  tag: PredictiveViewModelTag;
  onAssignTag: (tagName: string) => void;
};

const PredictiveViewModelTag: React.FC<ItemProps> = ({ tag, onAssignTag }: ItemProps) => {
  const { t } = useTranslation();
  const [isMouseOver, setIsMouseOver] = useState<boolean>(false);

  const handleMouseEnter = useCallback(() => {
    setIsMouseOver(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsMouseOver(false);
  }, []);

  const handleAssignTag = useCallback(
    (tagName: string) => {
      onAssignTag(tagName);
    },
    [onAssignTag]
  );

  return (
    <div
      className={classNames('pointer-events-auto flex gap-3 p-2', isMouseOver ? 'bg-gray-300' : null)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={() => handleAssignTag(tag.name)}
    >
      <div className="flex-1">{tag.name}</div>
      <div className="text-brand">
        <FontAwesomeIcon icon={faDiagramProject} />
      </div>
      <div>{t('viewModel.tag.predictive.count', { count: tag.assignedViewModelCount })}</div>
    </div>
  );
};

type Props = {
  predictiveTagList: PredictiveViewModelTag[];
  onAssignTag: (tagName: string) => void;
};

export const PredictiveViewModelTagList: React.FC<Props> = ({ predictiveTagList, onAssignTag }: Props) => {
  return (
    <>
      {predictiveTagList
        .filter((tag) => tag.assignedViewModelCount > 0)
        .map((tag) => (
          <PredictiveViewModelTag key={tag.id} tag={tag} onAssignTag={onAssignTag} />
        ))}
    </>
  );
};
